/* BIODERMIS · Überschriften so groß wie möglich, so klein wie nötig.
   Passt sich das längste Wort einer Überschrift oder Frage nicht in die Zeile, wird nur dieses Element
   verkleinert (mindestens auf 55 %), statt das Wort zu trennen. Wirkt auf jeder Bildschirmbreite. */
(function () {
  'use strict';
  var SEL = 'h1,h2,h3,h4,h5,h6,summary';
  var WORD = /[^\s\-\u2010-\u2015\/]+/g;
  var MIN = 0.55;
  var measured = new WeakMap();
  var frame = 0;
  function longestWord(el) {
    var max = 0, range = document.createRange();
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue, m;
      WORD.lastIndex = 0;
      while ((m = WORD.exec(text))) {
        range.setStart(node, m.index);
        range.setEnd(node, m.index + m[0].length);
        var rects = range.getClientRects();
        for (var i = 0; i < rects.length; i++) if (rects[i].width > max) max = rects[i].width;
      }
    }
    return max;
  }
  function fit(el) {
    if (!el.getClientRects().length || !el.clientWidth) return;
    var signature = el.clientWidth + '|' + el.textContent;
    if (measured.get(el) === signature) return;
    if (el.hasAttribute('data-bds-fit')) { el.style.removeProperty('font-size'); el.removeAttribute('data-bds-fit'); }
    var cs = getComputedStyle(el);
    var avail = el.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    if (!(avail > 0)) return;
    var size = parseFloat(cs.fontSize), word = longestWord(el);
    measured.set(el, signature);
    if (word <= avail + 0.5) return;
    var f = Math.max(size * avail / word * 0.985, size * MIN);
    el.style.setProperty('font-size', f + 'px', 'important');
    el.setAttribute('data-bds-fit', '1');
    for (var i = 0; i < 8 && longestWord(el) > avail + 0.5 && f > size * MIN; i++) {
      f = Math.max(f * 0.96, size * MIN);
      el.style.setProperty('font-size', f + 'px', 'important');
    }
  }
  function run() {
    frame = 0;
    var list = document.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) fit(list[i]);
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(run); }
  function invalidate() { measured = new WeakMap(); schedule(); }
  var timer;
  function later() { clearTimeout(timer); timer = setTimeout(invalidate, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  window.addEventListener('load', schedule);
  window.addEventListener('resize', later);
  window.addEventListener('orientationchange', later);
  document.addEventListener('toggle', schedule, true);
  document.addEventListener('shopify:section:load', invalidate);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(invalidate);
  window.bdsTypoFit = invalidate;
})();
